module.exports = __webpack_public_path__ + "static/img/chrome_window_3.de9d79b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/step/chrome_window_3.png
// module id = e+uI
// module chunks = 94